import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { CompanyAuthConfigQuery } from "../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const companyAuthConfigQuery = graphql(`
  query companyAuthConfig {
    company {
      authConfig {
        requireTwoFactor
        allowPasswordLogin
        allowGoogleLogin
        allowMicrosoftLogin
        restrictMcpCredentialsToAdmins
      }
    }
  }
`);

export type CompanyAuthConfig = CompanyAuthConfigQuery["company"]["authConfig"];

// Reads the current company's authentication settings (2FA requirement, login methods, MCP
// credential restriction). Used by the Security section, Change password and the MCP credentials
// page. Writes go through useUpdateCompany. Refetched whenever a component using it mounts: the
// cached copy never goes stale, and another admin may have changed it.
export function useCompanyAuthConfig(
  options?: UseQueryOptions<CompanyAuthConfigQuery, unknown, CompanyAuthConfigQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["company_auth_config"], companyAuthConfigQuery, [], {
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
    refetchOnMount: "always",
    ...options,
  });
  return { data: data?.company.authConfig, ...rest };
}
